import { render, staticRenderFns } from "./examHistoryList.vue?vue&type=template&id=412794a2&scoped=true&"
import script from "./examHistoryList.vue?vue&type=script&lang=js&"
export * from "./examHistoryList.vue?vue&type=script&lang=js&"
import style0 from "./examHistoryList.vue?vue&type=style&index=0&id=412794a2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "412794a2",
  null
  
)

export default component.exports